import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { useQuery } from "react-apollo";
import gql from "graphql-tag";

import moment from "moment";

import { getDaysDiffBetweenDates, round } from "../../../../../utils";

import "./CancelledInfo.scss";

const CANCELLED_ORDER_QUERY = gql`
  query Order($where: OrderWhereUniqueInput!) {
    Order(where: $where) {
      RecId
      VoidDate
      VoidReason
      VoidNotificationContact
      VoidNotificationDate
      VoidNotificationBy
      VoidDispatcherRecIdRef
      VoidStatusRecIdRef
      VoidApprovedByRecIdRef
      VoidComments
      ScheduledDeliveryDate
    }
  }
`;

const CancelledInfo = ({ orderRecId }) => {
  const { data } = useQuery(CANCELLED_ORDER_QUERY, {
    variables: { where: { RecId: orderRecId } }
  });

  const [notice, setNotice] = useState("");

  const order = data?.Order ?? {};

  useEffect(() => {
    if (order.ScheduledDeliveryDate && order.VoidNotificationDate) {
      const daysDiff = getDaysDiffBetweenDates(
        new Date(order.VoidNotificationDate),
        new Date(order.ScheduledDeliveryDate)
      );
      const hours = daysDiff * 24;
      setNotice(hours);
    }
  }, [order.ScheduledDeliveryDate, order.VoidNotificationDate]);

  if (!order.VoidNotificationDate) return null;

  return (
    <div className="cancelled-info-container">
      <b>
        <em>
          Cancelled on {moment(order.VoidNotificationDate).format("MM/DD/YY")}{" "}
          at {moment(order.VoidNotificationDate).format("HH:mm")} (
          {round(notice, 2)} hrs)
        </em>
      </b>
    </div>
  );
};

CancelledInfo.propTypes = {
  orderRecId: PropTypes.number
};

export default CancelledInfo;
